import LoginScreen from "../../screens/LoginScreen";
import { connect } from "react-redux";
import { login } from "../actions/authActions";

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
  isFetching: state.user.isFetching,
});

const mapDispatchToProps = (dispatch) => ({
  loginUser: (email, password) => dispatch(login(email, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);
